module.exports = __webpack_public_path__ + "static/media/hemophilia.bf3a986a.jpg";